import Card from "@mui/material/Card";
import MDBox from "components/MDBox";
import MDTypography from "components/MDTypography";
import DefaultItem from "parts/Items/DefaultItem";

import { useContext } from "react";
import { LanguageContext } from "context";
import { CalendarEvent } from "@shared/api/tasks";

interface NextEventsProps {
  thisMonthTasks: CalendarEvent[];
  nextMonthTasks: CalendarEvent[];
}

function NextEvents({ thisMonthTasks, nextMonthTasks }: NextEventsProps): JSX.Element {
  const { t } = useContext(LanguageContext) as any;

  return (
    <Card sx={{ height: "100%" }}>
      <MDBox p={2}>
        <MDTypography variant="h6" fontWeight="medium" mb={1}>
          {t("FullCalendar.eventTitle")}
        </MDTypography>
        {thisMonthTasks.length > 0 ? (
          thisMonthTasks.map((task, index) => (
            <MDBox key={task.id} mt={index === 0 ? 0 : 3.5}>
              <DefaultItem
                color="error" // 今月のタスクはerror色
                icon="event"
                title={task.title}
                description={
                  task.planned_start
                    ? new Date(task.planned_start).toLocaleDateString()
                    : t("FullCalendar.dateTBD")
                }
              />
            </MDBox>
          ))
        ) : (
          <MDTypography variant="body2" color="text" textAlign="center" py={2}>
            {t("FullCalendar.noEvents")}
          </MDTypography>
        )}

        <MDBox mt={4}>
          <MDTypography variant="h6" fontWeight="medium" mb={1}>
            {t("FullCalendar.nextEventTitle")}
          </MDTypography>
          {nextMonthTasks.length > 0 ? (
          nextMonthTasks.map((task, index) => (
            <MDBox key={task.id} mt={index === 0 ? 0 : 3.5}>
              <DefaultItem
                color="success" // 来月のタスクはsuccess色
                icon="event"
                title={task.title}
                description={
                  task.planned_start
                    ? new Date(task.planned_start).toLocaleDateString()
                    : t("FullCalendar.dateTBD")
                }
              />
            </MDBox>
          ))
        ) : (
            <MDTypography variant="body2" color="text" textAlign="center" py={2}>
              {t("FullCalendar.nextNoEvents")}
            </MDTypography>
          )}
        </MDBox>
      </MDBox>
    </Card>
  );
}

export default NextEvents;